import _ from "lodash"
import { useScreenStore } from "../../../stores/ScreenStore"
import { Event } from "../../../types/types"
import { hexColor } from "../../../enums/colors"
import { t } from "i18next"
import { getCurrentStatus } from "../../../lib/calculations"

export function MonitorStatus() {
    const {monitorData} = useScreenStore()
    let statuses = Object.entries(monitorData).map(i => i[1] && i[1].length > 0 && getCurrentStatus(i[1]))

    return (
        <div className="px-6">
            <div className="bg-muted rounded-md h-10 mb-4 grid grid-cols-7 px-2 gap-2 items-center text-sm font-medium w-full relative">
                <MonitorStatusItem title="in_work" count={statuses.filter(s => s === 'worked').length} color={hexColor.worked} inverse={false}/>
                <MonitorStatusItem title="in_idle" count={statuses.filter(s => s === 'stopped').length} color={hexColor.stopped} inverse={true}/>
                <MonitorStatusItem title="in_maintenance" count={statuses.filter(s => s === 'maintenance').length} color={hexColor.maintenance} inverse={true}/>
                <MonitorStatusItem title="in_broken" count={statuses.filter(s => s === 'broken').length} color={hexColor.broken} inverse={false}/>
                <MonitorStatusItem title="in_repair" count={statuses.filter(s => s === 'repair').length} color={hexColor.repair} inverse={true}/>
                <MonitorStatusItem title="in_service" count={statuses.filter(s => s === 'service').length} color={hexColor.service} inverse={true}/>
                <MonitorStatusItem title="turned_off" count={statuses.filter(s => s === 'turned_off').length} color={hexColor.turned_off} inverse={true}/>
                <MonitorStatusItem title="in_other" count={statuses.filter(s => s === 'other').length} color={hexColor.other} inverse={true}/>
            </div>
        </div>
    )
}

function MonitorStatusItem({count, title, color, inverse}:{count: number, title: string, color: string, inverse: boolean}) {
    return (
        count ? 
        <div className={`h-6 rounded-md items-center flex ${inverse ? "text-black" : "text-white"} justify-between px-2`} style={{backgroundColor: color}}>
            <span>{t(`${title}`)}</span>
            <span>{count}</span>
        </div>
        :
        <></>
    )
}